// Cliente API específico para presupuestos (quotations)
// Usa fetch directo; si tu app ya tiene un request wrapper con interceptores
// puedes reemplazar por httpRequest.

const base = process.env.REACT_APP_API_URL || '/api';

async function apiFetch(path, options = {}) {
  const res = await fetch(base + path, {
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...(options.headers || {}) },
    ...options
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || 'Error API');
  }
  if (options.responseType === 'blob') return res.blob();
  return res.json();
}

export function createQuotation(payload) {
  return apiFetch('/api/quotations', { method: 'POST', body: JSON.stringify(payload) });
}
export function listQuotations(params = {}) {
  const qs = Object.entries(params).filter(([, v]) => v != null && v !== '').map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`).join('&');
  const url = '/api/quotations' + (qs ? `?${qs}` : '');
  return apiFetch(url);
}
export function getQuotationPDF(id) {
  return apiFetch(`/api/quotations/${id}/pdf`, { responseType: 'blob' });
}
export function updateQuotationStatus(id, status) {
  return apiFetch(`/api/quotations/${id}/status`, { method: 'PUT', body: JSON.stringify({ status }) });
}
export function convertQuotation(id, payload = {}) {
  return apiFetch(`/api/quotations/${id}/convert`, { method: 'POST', body: JSON.stringify(payload) });
}
export function getQuotation(id) {
  return apiFetch(`/api/quotations/${id}`);
}
